export default "__VITE_ASSET__3f7ca7b8__"